export default {
    duplicate: 'Doublon',
    invalid: 'Invalide',
    lost: 'Perdu',
    active: 'Actif',
    sale: '@.capitalize:lexicon.sold.singular',
};
